// snippet ranges can sometimes be missing when dealing with "truncated" diffs

import type {FileDiffReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {scrapeFileDiffRange} from './scrape-file-diff-range'

// ex: deleted files, dep lock files, etc
export const populateSnippetRanges = (fileDiffReference: FileDiffReference) => {
  const reference = {...fileDiffReference}

  if (reference.base && !reference.base.range.start) {
    const baseRange = scrapeFileDiffRange(fileDiffReference.id, 'base')
    if (baseRange) {
      reference.base.range = baseRange
    }
  }

  if (reference.head && !reference.head.range.start) {
    const headRange = scrapeFileDiffRange(fileDiffReference.id, 'head')
    if (headRange) {
      reference.head.range = headRange
    }
  }

  return reference
}
